/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

// tslint:disable:max-classes-per-file 
import { Action } from '@ngrx/store';

export const SET_DRAFT_FORM_DATA = '[Library] Set Draft Form Data';
export const SUBMIT_HIGHLIGHT_FORM = '[Library] Submit Highlight Form';
export const SUBMIT_HIGHLIGHT_FORM_SUCCESS = '[Library] Submit Highlight Form Success';
export const SUBMIT_HIGHLIGHT_FORM_FAIL = '[Library] Submit Highlight Form Fail';
export const RESET_HIGHLIGHT_REEL_FORM = '[Library] Reset Highlight Form';

export class SetDraftFormData implements Action {
  readonly type = SET_DRAFT_FORM_DATA;

  constructor(public payload: any) {}
}

export class SubmitHighlightForm implements Action {
  readonly type = SUBMIT_HIGHLIGHT_FORM;

  constructor(public payload: any) {}
}

export class SubmitHighlightFormFail implements Action {
  readonly type = SUBMIT_HIGHLIGHT_FORM_FAIL;

  constructor(public payload: any) {}
}

export class SubmitHighlightFormSuccess implements Action {
  readonly type = SUBMIT_HIGHLIGHT_FORM_SUCCESS;

  constructor(public payload: any) {}
}

export class ResetHighlightForm implements Action {
  readonly type = RESET_HIGHLIGHT_REEL_FORM;
}

export type SubmitHighlightFormAction =
  | SetDraftFormData
  | SubmitHighlightForm
  | SubmitHighlightFormFail
  | SubmitHighlightFormSuccess
  | ResetHighlightForm;
